<div class="invalid-feedback"
     *ngIf="isInvalid"
     style="display: block;">
  <ng-content></ng-content>
</div>